"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookie = void 0;
/**
 *
 */
class Cookie {
    /**
     * Get a cookie value by name.
     *
     * @param key
     */
    static get(key) {
        const name = key + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }
    /**
     * Set a cookie.
     *
     * @param name
     * @param value
     * @param duration
     */
    static set(name, value, duration = 0) {
        const d = new Date();
        const unixDayInMilliseconds = 86400000; // 24 * 60 * 60 * 1000
        if (duration === 0) {
            document.cookie = `${name}=${value};path=/`;
        }
        else {
            d.setTime(d.getTime() + duration * unixDayInMilliseconds);
            const expires = `expires=${d.toUTCString()}`;
            document.cookie = `${name}=${value};${expires};path=/`;
        }
    }
    /**
     * Deletes a cookie by setting it to an empty value and setting its expiration date in the past.
     *
     * @param name
     */
    static remove(name) {
        Cookie.set(name, '', -1);
    }
}
exports.Cookie = Cookie;
